import { DocumentNode, gql } from '@apollo/client';
import {
  Divider,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  Text,
} from '@chakra-ui/react';

import { EAtMentionNotificationSetting } from '@/graphql-types/globalTypes';
import { Card } from '@/imports/ui/chakra/components/Card';

import { UserNotifications_User } from './graphql-types/UserNotifications_User';

export const UserNotifications: React.FC<{
  user: UserNotifications_User;
  isDisabled?: boolean;
  onChange: (data: {
    privateMessageNotification?: boolean;
    atMentionNotification?: EAtMentionNotificationSetting;
  }) => Promise<void>;
}> & { userFragment: DocumentNode } = ({ user, isDisabled, onChange }) => {
  return (
    <>
      <Card overflow="hidden">
        <Stack spacing="0">
          <Text fontSize="sm" p="4" bg="secondary.500" color="textPrimary.500" fontWeight="600">
            User
          </Text>
          <Divider />
          <Stack spacing="0">
            <Stack px="4" py="4">
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              w="full"
              isDisabled={isDisabled}
              opacity="1"
            >
              <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Private Messages</FormLabel>
              <Switch
                isChecked={
                  user.privateMessageNotification === null ||
                  user.privateMessageNotification === undefined
                    ? true
                    : user.privateMessageNotification
                }
                onChange={async ({ target: { checked } }) => {
                  await onChange({
                    privateMessageNotification: checked,
                  });
                }}
              />
            </FormControl>
            </Stack>
            <Divider border="1px solid" borderColor="secondary.500" mt="0" />
            <Stack px="4" py="4">
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              w="full"
              isDisabled={isDisabled}
            >
              <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Mentions</FormLabel>
              <Switch
                isChecked={
                  user.atMentionNotification === null ||
                  user.atMentionNotification === undefined ||
                  user.atMentionNotification ===
                    EAtMentionNotificationSetting.REALTIME
                    ? true
                    : false
                }
                onChange={async ({ target: { checked } }) => {
                  await onChange({
                    atMentionNotification: checked
                      ? EAtMentionNotificationSetting.REALTIME
                      : EAtMentionNotificationSetting.OFF,
                  });
                }}
              />
            </FormControl>
            </Stack>

          </Stack>
        </Stack>
      </Card>
    </>
  );
};
UserNotifications.userFragment = gql`
  fragment UserNotifications_User on User {
    _id
    privateMessageNotification
    atMentionNotification
  }
`;
